import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  FeatureCard,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import Lottie from "react-lottie";
import { useLocation } from "react-router";

export default function Leaders() {
  useEffect(() => {}, []);
  const location = useLocation();
  const state = useSelector((state) => state);
  console.log(location.state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div style={{ minHeight: "100vh", width: "100vw", padding: "200px" }}>
          <img src={location.state.image} style={{ borderRadius: "5px" }} />
          <h1>{location.state.subtitle}</h1>
          <h3>{location.state.title}</h3>
          <br />
          <hr />
          <br />
          <div>{location.state.content}</div>
        </div>

        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
